import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'hooks/useTranslation';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';
import { rootPaths } from 'routes/paths';

export const TermsAndConditionsLabel = () => {
  const classes = useStyles();
  const { t } = useTranslation('auth');

  return (
    <Typography variant="caption" className={classes.termsAndConditionsText}>
      {t('termsAndConditions.iAgreeToThe')}{' '}
      <Link target={'_blank'} to={rootPaths.static.termsAndConditions}>
        {t('termsAndConditions.termsAndConditions')}{' '}
      </Link>
      {t('and', { ns: 'common' })}{' '}
      <Link target={'_blank'} to={rootPaths.static.privacyPolicy}>
        {t('termsAndConditions.privacyPolicy')}{' '}
      </Link>
    </Typography>
  );
};
